import { SvgIcon } from '@mui/material';

const FrozenIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8 4v8M6.5 2.5 8 4l1.5-1.5m-3 11L8 12l1.5 1.5M4.537 6l6.925 4M2.488 6.55 4.538 6l-.55-2.05m8.025 8.1-.55-2.05 2.05-.55M4.537 10l6.925-4m-7.474 6.05.55-2.05-2.05-.55m11.025-2.9L11.463 6l.55-2.05"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default FrozenIcon;
